module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-700.woff2?e535f7856b24153e0f3146e8f90a45c5";